import { Button, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useFormikContext, Form } from 'formik'

import { useRequest2FAEmailDisable } from 'src/hooks'
import { ETranslationNs, IVerificationCodeForm } from 'src/types'
import { useStyles } from '../../styles'
import { QRCodeSVG } from 'qrcode.react'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { handleTrimValueOnPaste } from 'src/common/handlers'

interface IProps {
  totpUri?: string | null
}

export const SwitchForm = ({ totpUri }: IProps) => {
  const [t] = useTranslation(ETranslationNs.UserProfile)
  const classes = useStyles()
  const { mutate: sendCode, isLoading: isSending } = useRequest2FAEmailDisable()

  const { isSubmitting, dirty, values, errors, handleChange, setFieldValue } =
    useFormikContext<IVerificationCodeForm>()

  const handleSendCode = () => {
    sendCode()
  }

  const buttonDis = isSubmitting || !dirty || !!Object.keys(errors).length || isSending

  return (
    <Form className={classes.form}>
      <div className={classes.disableUpperWrapper}>
        <h3 className={classes.sectionTitle}>
          <HelperWrapper ns={ETranslationNs.UserProfile} t="2fa-change-title" />
        </h3>
        <p className={classes.sectionText}>
          {totpUri ? (
            <HelperWrapper ns={ETranslationNs.UserProfile} t="2fa-email-change-totp-text" />
          ) : (
            <HelperWrapper ns={ETranslationNs.UserProfile} t="2fa-email-change-text" />
          )}
        </p>
        {totpUri && <div className={classes.qrCodeReqWrapper}>{<QRCodeSVG value={totpUri} />}</div>}
        {!totpUri && (
          <Button
            className={classes.codeButton}
            size="small"
            disabled={isSending}
            onClick={handleSendCode}
          >
            <HelperWrapper ns={ETranslationNs.UserProfile} t="2fa-modal-email-send-button" />
          </Button>
        )}
      </div>
      <TextField
        fullWidth
        placeholder={t('2fa-code-input-placeholder.v') + '*'}
        autoComplete="off"
        name="code"
        value={values.code}
        helperText={errors.code ? <HelperWrapper t={errors.code} /> : ' '}
        FormHelperTextProps={{ error: !!errors.code }}
        variant="standard"
        onChange={handleChange}
        onPaste={(event) => handleTrimValueOnPaste(event, values.code, setFieldValue, 'code')}
      />

      <Button type="submit" variant="contained" disabled={buttonDis}>
        {totpUri ? (
          <HelperWrapper ns={ETranslationNs.UserProfile} t="2fa-modal-switch-button" />
        ) : (
          <HelperWrapper ns={ETranslationNs.UserProfile} t="2fa-email-switch-button" />
        )}
      </Button>
    </Form>
  )
}
